import type { GameState } from './types';

/**
 * Deterministic RNG (mulberry32) whose state lives in GameState, so a saved
 * game replays identically and tests can seed it. Never use Math.random in core/.
 */
export function rand(s: GameState): number {
  s.rng = (s.rng + 0x6d2b79f5) >>> 0;
  let t = s.rng;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

export function randRange(s: GameState, min: number, max: number): number {
  return min + rand(s) * (max - min);
}

export function randInt(s: GameState, min: number, maxInclusive: number): number {
  return Math.floor(randRange(s, min, maxInclusive + 1));
}

export function pickWeighted<T>(s: GameState, entries: readonly (readonly [T, number])[]): T {
  const total = entries.reduce((sum, [, w]) => sum + w, 0);
  let roll = rand(s) * total;
  for (const [value, weight] of entries) {
    roll -= weight;
    if (roll <= 0) return value;
  }
  return entries[entries.length - 1]![0];
}

/** Poisson-process spawn check: true with probability dtMs / meanMs. */
export function chance(s: GameState, dtMs: number, meanSec: number): boolean {
  return rand(s) < dtMs / (meanSec * 1000);
}
